module.exports = __webpack_public_path__ + "img/sochi-club-un.f08ca968.png";